// API requests always use the configured backend, including on custom domains.
// OAuth return navigation separately uses the browser origin in AuthContext.
export const getApiBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL?.trim();
  if (!configuredUrl) {
    throw new Error('REACT_APP_BACKEND_URL must be configured');
  }
  return configuredUrl.replace(/\/+$/, '');
};

export const API_BASE = getApiBaseUrl();
export const API = `${API_BASE}/api`;
